import { ButtonHTMLAttributes } from "react";

import { className } from "@/common/utils/strings";

import classes from "./secondaryButton.module.css";

export type SecondaryButtonProps = {
  variant?: "default" | "active";
} & ButtonHTMLAttributes<HTMLButtonElement>

const SecondaryButton = (props: SecondaryButtonProps) => {
  const {
    variant = "default",
    children,
    ...buttonProps
  } = props;

  const buttonClassName = className({
    [classes.btn]: true,
    [variant === "default" ? classes.default : classes.active]: true,
    [props.className ?? ""]: true,
  });

  return (
    <button {...{ ...buttonProps, className: buttonClassName }}>
      { children }
    </button>
  );
};

export default SecondaryButton;
